module.exports = __webpack_public_path__ + "img/you@3x.adc6445c.png";